// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/CircularStd-Book.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/CircularStd-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/CircularStd-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/OpenSans-VariableFont_wdth,wght.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Font Faces */

@font-face {
  font-family: 'Circular Std';
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format(woff2);
}

@font-face {
  font-family: 'Circular Std';
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format(woff2);
}

@font-face {
  font-family: 'Circular Std';
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format(woff2);
}

@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-optical-sizing: auto;
  font-weight: 300 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format(woff2);
}

@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-optical-sizing: auto;
  font-weight: 300 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format(woff2);
}

/* Global Styles */
/* These should be styles that can't rely on React to render styled-components */
/* All other global styles should be in global-styles.js */

/* This is to override styles of antd text components where
  there is additional spacing added to anything with a font-weight of 400 */
* {
  font-variant: none !important;
  font-feature-settings: normal !important;
}

body {
  font-family: 'Open Sans', sans-serif !important;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
}

body p {
  margin-bottom: 0;
}

body strong {
  font-weight: 700;
  font-variation-settings: 'wght' 700;
}

body h1,
body h2 {
  font-family: 'Circular Std', 'Open Sans', sans-serif;
  font-weight: 900;
}

body h3,
body h4,
body h5,
body h6 {
  font-family: 'Circular Std', 'Open Sans', sans-serif;
  font-weight: 700;
}

p {
  margin-bottom: 0;
}

/* Helper class for elements that are not styled components or their children */
.overflow-hidden {
  overflow: hidden !important;
}

/* Remove default close button in google maps hover effect as it is not functional */
#map button.gm-ui-hover-effect {
  display: none !important;
}

@keyframes antZoomIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes antZoomOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.ant-modal {
  animation-duration: 0.4s !important;
  animation-timing-function: ease-in-out !important;
}

/* Hack to hide tracking pixels which shouldn't be visible but mess up the layout */
img[width='1'][height='1'][border='0'][alt][src*='.com/?id='] {
  position: absolute;
  left: -9999px;
  top: -9999px;
}
`, "",{"version":3,"sources":["webpack://./app/app.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,0DAA+D;AACjE;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,0DAA+D;AACjE;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,0DAAgE;AAClE;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,0DAA8E;AAChF;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,0DAA8E;AAChF;;AAEA,kBAAkB;AAClB,gFAAgF;AAChF,0DAA0D;;AAE1D;2EAC2E;AAC3E;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;EAEE,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;;;;EAIE,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,2BAA2B;AAC7B;;AAEA,oFAAoF;AACpF;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA,mFAAmF;AACnF;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd","sourcesContent":["/* Font Faces */\n\n@font-face {\n  font-family: 'Circular Std';\n  font-weight: 500;\n  src: url('./assets/fonts/CircularStd-Book.woff2') format(woff2);\n}\n\n@font-face {\n  font-family: 'Circular Std';\n  font-weight: 700;\n  src: url('./assets/fonts/CircularStd-Bold.woff2') format(woff2);\n}\n\n@font-face {\n  font-family: 'Circular Std';\n  font-weight: 900;\n  src: url('./assets/fonts/CircularStd-Black.woff2') format(woff2);\n}\n\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-optical-sizing: auto;\n  font-weight: 300 800;\n  src: url('./assets/fonts/OpenSans-VariableFont_wdth,wght.woff2') format(woff2);\n}\n\n@font-face {\n  font-family: 'Open Sans';\n  font-style: italic;\n  font-optical-sizing: auto;\n  font-weight: 300 800;\n  src: url('./assets/fonts/OpenSans-VariableFont_wdth,wght.woff2') format(woff2);\n}\n\n/* Global Styles */\n/* These should be styles that can't rely on React to render styled-components */\n/* All other global styles should be in global-styles.js */\n\n/* This is to override styles of antd text components where\n  there is additional spacing added to anything with a font-weight of 400 */\n* {\n  font-variant: none !important;\n  font-feature-settings: normal !important;\n}\n\nbody {\n  font-family: 'Open Sans', sans-serif !important;\n  font-weight: 400;\n  -webkit-font-smoothing: antialiased;\n}\n\nbody p {\n  margin-bottom: 0;\n}\n\nbody strong {\n  font-weight: 700;\n  font-variation-settings: 'wght' 700;\n}\n\nbody h1,\nbody h2 {\n  font-family: 'Circular Std', 'Open Sans', sans-serif;\n  font-weight: 900;\n}\n\nbody h3,\nbody h4,\nbody h5,\nbody h6 {\n  font-family: 'Circular Std', 'Open Sans', sans-serif;\n  font-weight: 700;\n}\n\np {\n  margin-bottom: 0;\n}\n\n/* Helper class for elements that are not styled components or their children */\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n/* Remove default close button in google maps hover effect as it is not functional */\n#map button.gm-ui-hover-effect {\n  display: none !important;\n}\n\n@keyframes antZoomIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes antZoomOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.ant-modal {\n  animation-duration: 0.4s !important;\n  animation-timing-function: ease-in-out !important;\n}\n\n/* Hack to hide tracking pixels which shouldn't be visible but mess up the layout */\nimg[width='1'][height='1'][border='0'][alt][src*='.com/?id='] {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
